import { render, staticRenderFns } from "./StudyMaterials.vue?vue&type=template&id=07c52d6a&scoped=true"
import script from "./StudyMaterials.vue?vue&type=script&lang=js"
export * from "./StudyMaterials.vue?vue&type=script&lang=js"
import style0 from "./StudyMaterials.vue?vue&type=style&index=0&id=07c52d6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c52d6a",
  null
  
)

export default component.exports